import { render, staticRenderFns } from "./GlobalModal.vue?vue&type=template&id=32be77a4&scoped=true&"
import script from "./GlobalModal.vue?vue&type=script&lang=js&"
export * from "./GlobalModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalModal.vue?vue&type=style&index=0&id=32be77a4&lang=scss&scoped=true&"
import style1 from "./GlobalModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be77a4",
  null
  
)

export default component.exports